export default __webpack_public_path__ + "static/media/VF_condiciones_generales_recurso_ordinario_2025.bc1721d4.pdf";